<video [autoplay]='autoplay' [controls]='controls' [controlsList]='controlsList' disablePictureInPicture>
  <source [src]='streamSource' type='video/mp4' />
  Your browser does not support the video tag.
</video>
